import { generatePath, Link } from 'react-router';
import sanitize from 'sanitize-html';

import paths from '@/lib/paths';
import { toDateString } from '@/lib/utils/date';

import type { Note } from '../../types';

type Props = {
  note: Note;
};

export default function NoteItem({ note }: Props) {
  if (note.text.trim() === '') return null;

  return (
    <Link
      to={generatePath(paths.notes.detail, { id: note.activity_id })}
      className="shadow-card flex shrink-0 flex-col overflow-hidden rounded-lg border pb-2"
    >
      <div className="flex justify-between border-b bg-neutral-50 p-2 dark:bg-neutral-900">
        <span className="text-sm">{note.broker_name}</span>

        <span className="text-muted-foreground text-sm">
          {toDateString(note.created_at)}
        </span>
      </div>

      <div className="relative max-h-60 overflow-hidden p-2">
        <div
          className="text-xs"
          dangerouslySetInnerHTML={{ __html: sanitize(note.text) }}
        />

        <div className="to-background absolute top-52 right-0 left-0 flex h-8 w-full items-center justify-center bg-linear-to-b from-transparent" />
      </div>
    </Link>
  );
}
